export enum ModalType {
  EMI_OPTIONS = 'EMI_OPTIONS',
  PROMOS_AND_COUPONS = 'PROMOS_AND_COUPONS',
  MORE_FILTER_OPTIONS = 'MORE_FILTER_OPTIONS',
  PAYMENT_DIALOG = 'PAYMENT_DIALOG',
  DESCRIPTION_AND_SPECIFICATIONS = 'DESCRIPTION_AND_SPECIFICATIONS',
  MULTIMEDIA = 'MULTIMEDIA',
  ALL_CATEGORIES_DIALOG = 'ALL_CATEGORIES_DIALOG',
  PDP_REQUESTS = 'PDP_REQUESTS',
  WRITE_A_REVIEW_POPUP = 'WRITE_A_REVIEW_POPUP',
  BRAND_CATEGORY_LISTING = 'BRAND_CATEGORY_LISTING',
  COMMON_CONFIRMATION_POPUP = 'COMMON_CONFIRMATION_POPUP',
  REVIEW_FORM_DIALOG = 'REVIEW_FORM_DIALOG',
  ERROR_POPUP = 'ERROR_POPUP',
  HIGH_VALUE = 'HIGH_VALUE',
  GSTIN_UPDATION_IN_ADDRESS_CONFIRMATION = 'GSTIN_UPDATION_IN_ADDRESS_CONFIRMATION',
  IFRAME_POPUP = 'IFRAME_POPUP',
  IB_CREDIT_PAYMENT_DIALOG = 'IB_CREDIT_PAYMENT_DIALOG',
  EXPLORE_FAMILIES = 'EXPLORE_FAMILIES',
  REVIEW_POPUP = 'REVIEW_POPUP',
  MULTISELECT_POPUP = 'MULTISELECT_POPUP',
  POLICY_POPUP = 'POLICY_POPUP',
  IB_CREDIT_CONFIRMATION_POPUP = 'IB_CREDIT_CONFIRMATION_POPUP',
  QUOTATION_POPUP = 'QUOTATION_POPUP',
}

export enum PostMessageTypeEnum {
  ACTION = 'ACTION',
  PAGE_FETCH = 'PAGE_FETCH',
}
